import { setFlag } from "./flags";

let cache = {};

export const cacheRows = (rows) => {
	for (const row of rows) cache[row.key] = row;
};

export const syncFlags = (data) => {
	for (const key in cache) {
		const row = data.curData.values.table.productExclusion.list.find(
			(row) => row.key === key,
		);
		if (row) setFlag(data, row.key, !!cache[key].list[0]);
	}
};

export const pullAllChanges = (rows) => {
	for (const key in cache)
		if (!rows.find((row) => row === key)) rows.push(cache[key]);
};

export const clearCache = () => {
	cache = {};
};

window.addEventListener("gr-event", (ev) => {
	if (ev.detail.action === "stack" && ev.detail.type === "back") clearCache();
});
